define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/StorageUtil',
	'internal_util/LocalizationUtil',
	'model/Context',
	'model/ErrorType',
	'factory/AuthenticationOptionsFactory',
	'factory/AuthenticationOptionGroupsFactory',
	'factory/RequestedAttributesFactory',
	'factory/CloudIdentityFactory',
	'state/InitializationState',
	'state/ErrorState',
	'state/TimeoutErrorState',
	'state/RecoveryStrategyState',
	'state/ActivationState',
	'state/AuthenticationOptionSelectionState',
	'state/AttributesSelectionState',
	'state/IdentityTransferState',
	'state/IdentitiesOverviewState',
	'state/IdentityManagementState',
	'state/IdentityCreationState',
	'state/IdentitiesRevokationState',
	'state/IdentitiesRevokationSucceededState',
	'state/ScanQRCodeState',
	'state/PrivacyPolicyState',
	'state/ResolveCloudIDState',
	'state/BindingState',
	'service/Core',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'interceptor/RecoveryStrategyInterceptor',
	'interceptor/IdentityCreationInterceptor',
	'mainview/ModalView',
	'view/LoadingView',
	'lib/jquery'
], function (
		Logger,
		Util,
		UiUtil,
		StorageUtil,
		LocalizationUtil,
		Context,
		ErrorType,
		AuthenticationOptionsFactory,
		AuthenticationOptionGroupsFactory,
		RequestedAttributesFactory,
		CloudIdentityFactory,
		InitializationState,
		ErrorState,
		TimeoutErrorState,
		RecoveryStrategyState,
		ActivationState,
		AuthenticationOptionSelectionState,
		AttributesSelectionState,
		IdentityTransferState,
		IdentitiesOverviewState,
		IdentityManagementState,
		IdentityCreationState,
		IdentitiesRevokationState,
		IdentitiesRevokationSucceededState,
		ScanQRCodeState,
		PrivacyPolicyState,
		ResolveCloudIDState,
		BindingState,
		Core,
		UIStateManager,
		EventListenerRegistry,
		RecoveryStrategyInterceptor,
		IdentityCreationInterceptor,
		ModalView,
		LoadingView,
		jQuery
		) {
	'use strict';

	return function (core) {
		var _core,
				_uiStateManager = null,
				_mainView = null,
				_loadingView = null;

		if (core instanceof Core) {
			_core = core;
		} else {
			throw new Error('core invalid');
		}

		EventListenerRegistry.addOneTimeListener('CORE_INITIALIZATION_FAILED', initializationError);
		EventListenerRegistry.addListener('UI_STATE_CHANGE_STARTED', uiStateChangeStarted);
		EventListenerRegistry.addListener('UI_STATE_CHANGE_FINISHED', uiStateChangeFinished);
		EventListenerRegistry.addListener('UI_STATE_INTERCEPTION_STARTED', uiStateChangeStarted);
		EventListenerRegistry.addListener('UI_STATE_INTERCEPTION_FINISHED', uiStateInterceptionFinished);


		// private methods

		function initializationError(error) {
			_mainView = new ModalView();
			_uiStateManager = new UIStateManager(_core, _mainView);

			_uiStateManager.add(new ErrorState(_uiStateManager));
			_uiStateManager.change('error', error);

			jQuery('body').append(_mainView.get());

			_mainView.show();
		}

		function createUIStates() {
			_uiStateManager.add(new InitializationState(_uiStateManager));
			_uiStateManager.add(new ErrorState(_uiStateManager));
			_uiStateManager.add(new TimeoutErrorState(_uiStateManager));
			_uiStateManager.add(new AttributesSelectionState(_uiStateManager));
			_uiStateManager.add(new RecoveryStrategyState(_uiStateManager));
			_uiStateManager.add(new ActivationState(_uiStateManager));
			_uiStateManager.add(new BindingState(_uiStateManager));

			switch (_core.context()) {
				case Context.SERVICE_PROVIDER:
					_uiStateManager.add(new AuthenticationOptionSelectionState(_uiStateManager));
					if (StorageUtil.read("origin_url") === null && document.referrer !== "") {
						StorageUtil.store("origin_url", document.referrer, true);
					}
					break;
				case Context.CLOUD_IDENTITIES_MANAGEMENT:
					_uiStateManager.add(new IdentityTransferState(_uiStateManager));
					_uiStateManager.add(new IdentitiesOverviewState(_uiStateManager));
					_uiStateManager.add(new IdentityManagementState(_uiStateManager));
					_uiStateManager.add(new IdentityCreationState(_uiStateManager));
					_uiStateManager.add(new IdentitiesRevokationState(_uiStateManager));
					_uiStateManager.add(new IdentitiesRevokationSucceededState(_uiStateManager));
					_uiStateManager.add(new ScanQRCodeState(_uiStateManager));
					_uiStateManager.add(new PrivacyPolicyState(_uiStateManager));
					_uiStateManager.add(new ResolveCloudIDState(_uiStateManager));
					break;
			}
		}

		function createUIStateChangeInterceptors() {
			_uiStateManager.addInterceptor(new RecoveryStrategyInterceptor(_core, _uiStateManager));
			_uiStateManager.addInterceptor(new IdentityCreationInterceptor(_core, _uiStateManager));
		}

		function initServiceProvider() {
			EventListenerRegistry.addOneTimeListener('CORE_SUCCEEDED', function (doneCallback) {
				var authenticationOption = StorageUtil.read('authentication_option'),
						requestedAttributes = StorageUtil.read('requested_attributes'),
						cloudIdentity = StorageUtil.read('cloud_identity'),
						oneTimeIdentity = StorageUtil.read('one_time_identity');

				StorageUtil.remove('authentication_option');
				StorageUtil.remove('requested_attributes');
				StorageUtil.remove('cloud_identity');
				StorageUtil.remove('one_time_identity');

				if (authenticationOption !== null && requestedAttributes !== null && cloudIdentity !== null) {
					if (authenticationOption.hasOwnProperty('authenticationOptions')) {
						authenticationOption = AuthenticationOptionGroupsFactory.createFromObject(authenticationOption);
					} else {
						authenticationOption = AuthenticationOptionsFactory.createFromObject(authenticationOption);
					}

					requestedAttributes = RequestedAttributesFactory.createFromObject(requestedAttributes);
					cloudIdentity = CloudIdentityFactory.createFromObject(cloudIdentity);

					if (oneTimeIdentity) {
						EventListenerRegistry.addOneTimeListener(['ACTIVATION_SUCCEEDED', 'ACTIVATION_FAILED', 'ABORT'],
								function (data, doneCallback) {
									_core.cloudIdentitiesManager().deleteCloudIdentity(cloudIdentity, true, doneCallback, doneCallback);
								});
					}

					_uiStateManager.change('attributes_selection', {
						authenticationOption: authenticationOption,
						requestedAttributes: requestedAttributes,
						identity: cloudIdentity
					});
				} else {
					_uiStateManager.change('authentication_option_selection');
				}

				Util.callCallbacks(doneCallback);
			});
		}

		function initCloudIdentitiesManagement() {
			var cloudIdentity = null,
				authFlowId = null,
				callback = function (result, doneCallback) {
					cloudIdentity = result.identity;
					authFlowId = result["flow-id"];
					Util.callCallbacks(doneCallback);
				},
				errorCallback = function (error, doneCallback) {
					_uiStateManager.change('error', {
						error: error,
						nextCallback: function () {
							if (StorageUtil.read('authentication_option') !== null) {
								StorageUtil.remove('authentication_option');

								_uiStateManager.changeContext();
							} else {
								_uiStateManager.change('identities_overview');
							}
						}
					});

					Util.callCallbacks(doneCallback);
				};
				
			//If renew was triggert from SPContext
			var renew = StorageUtil.read('renew_cid');
			StorageUtil.remove('renew_cid');

			EventListenerRegistry.addOneTimeListener('GET_CLOUD_IDENTITY_SUCCEEDED', callback);
			EventListenerRegistry.addOneTimeListener(['REVOKE_CLOUD_IDENTITIES_FAILED', 'GET_CLOUD_IDENTITY_FAILED'], errorCallback);

			EventListenerRegistry.addOneTimeListener('CORE_SUCCEEDED', function (doneCallback) {
				var parameters = _core.parameters(),
						authenticationOption = StorageUtil.read('authentication_option'),
						requestedAttributes = StorageUtil.read('requested_attributes');

				EventListenerRegistry.removeListener('GET_CLOUD_IDENTITY_SUCCEEDED', callback);
				EventListenerRegistry.removeListener('GET_CLOUD_IDENTITY_FAILED', errorCallback);

				if (_core.contextChangeable() && authenticationOption !== null && requestedAttributes !== null) {
					if (authenticationOption.hasOwnProperty('authenticationOptions')) {
						authenticationOption = AuthenticationOptionGroupsFactory.createFromObject(authenticationOption);
					} else {
						authenticationOption = AuthenticationOptionsFactory.createFromObject(authenticationOption);
					}

					requestedAttributes = RequestedAttributesFactory.createFromObject(requestedAttributes);
				} else {
					StorageUtil.remove('authentication_option');
					StorageUtil.remove('requested_attributes');

					authenticationOption = null;
					requestedAttributes = null;
				}

				if (parameters.hasOwnProperty('revokecloudids-url')) {
					_uiStateManager.change('identities_revokation_succeeded');
				} else if (parameters.hasOwnProperty('trans') && parameters.hasOwnProperty('salt')) {
					_uiStateManager.change('identity_transfer', {
						transferURL: parameters['trans'],
						salt: parameters['salt']
					});
				} else if (parameters['cip-cmd'] ===  "issue" && parameters.hasOwnProperty('flow-id')) {
					_uiStateManager.change('binding', {
						'cip-cmd': parameters['cip-cmd'],
						'session' : parameters['flow-id'],
						renew : renew
					});
				} else if (parameters.hasOwnProperty('pair')) {
					_uiStateManager.change('identity_management', {
						'pair': Util.base64Decode(parameters['pair'])
					});
				} else if (parameters.hasOwnProperty('timeoutError')) {
					_uiStateManager.change('timeout_error', {
						'timeoutError': Util.base64Decode(parameters['timeoutError'])
					});
				} else if (cloudIdentity !== null) {
					_uiStateManager.change('identity_management', {
						identity: cloudIdentity,
						"flow-id": authFlowId,
						fromSP: (authenticationOption !== null),
						renew: renew
					});
				} else if (authenticationOption !== null && requestedAttributes !== null) {
					_uiStateManager.change('resolve_identity', {
						authenticationOption: authenticationOption,
						requestedAttributes: requestedAttributes,
						fromSP: true
					});
				} else {
					_uiStateManager.change('identities_overview', {renew: renew});
				}

				Util.callCallbacks(doneCallback);
			});
		}

		function uiStateChangeStarted(uiStates, doneCallback) {
			var nextContent = uiStates['next'].content(),
					previousContent;

			if (uiStates['previous'] !== null) {
				previousContent = uiStates['previous'].content();

				if (Util.isArray(nextContent) && Util.isArray(previousContent)) {
					previousContent[previousContent.length - 1].get().append(_loadingView.get());

					_loadingView.enableAnimation();
				}
			}

			Util.callCallbacks(doneCallback);
		}

		function uiStateChangeFinished(uiStates, doneCallback) {
			var nextState = uiStates['next'],
					nextContent = nextState.content(),
					i;

			uiStateInterceptionFinished(uiStates, function () {
				_mainView.setTitle(nextState.title());
				_mainView.setPoweredByLogo(nextState.poweredByImage());
				_mainView.setControls(nextState.controls().get());
				_mainView.clearBody();

				if (Util.isArray(nextContent)) {
					for (i = 0; i < nextContent.length; i++) {
						_mainView.appendToBody(nextContent[i].get());
					}
				} else {
					_mainView.appendToBody(nextContent.get());
				}

				_mainView.get().find('[autofocus]').focus();

				Util.callCallbacks(doneCallback);
			});
		}

		function uiStateInterceptionFinished(uiStates, doneCallback) {
			var previousContent,
					lastChild;

			if (uiStates['previous'] !== null && Util.isArray(uiStates['previous'].content())) {
				previousContent = uiStates['previous'].content();
				lastChild = previousContent[previousContent.length - 1].get().children().last();

				if (lastChild[0] === _loadingView.get()[0]) {
					lastChild.detach();

					_loadingView.disableAnimation();
				}
			}

			Util.callCallbacks(doneCallback);
		}


		// public methods

		this.init = function (callbacks) {
			_mainView = new ModalView();
			_uiStateManager = new UIStateManager(_core, _mainView);
			_loadingView = new LoadingView();

			jQuery('html').attr('lang', LocalizationUtil.getShortLocale());

			LocalizationUtil.setMainView(_mainView);

			createUIStates();
			createUIStateChangeInterceptors();

			_uiStateManager.change('initialization');
			
			jQuery('body').append(_mainView.get());

			_mainView.show(true, function () {
				UiUtil.preloadWebfonts(function () {
					UiUtil.preloadImages(null, function () {
						switch (_core.context()) {
							case Context.SERVICE_PROVIDER:
								initServiceProvider();
								break;
							case Context.CLOUD_IDENTITIES_MANAGEMENT:
								initCloudIdentitiesManagement();
								break;
						}

						Util.callCallbacks(callbacks);
					});
				});
			});
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/Ui.js
// module id = 300
// module chunks = 4